<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const DropdownArrowIcon = getIcon("DropdownArrowIcon");
</script>

{#if typeof DropdownArrowIcon === 'string'}
	<img src={DropdownArrowIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof DropdownArrowIcon === 'function'}
	<svelte:component this={DropdownArrowIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
